import axios from "axios";
import store from "@/store";
import { MessageBox } from "element-ui";
import { getToken } from "../utils/auth";
import { removeToken } from "@/utils/auth";
import { showLoading, hideLoading } from "../common/loading";

// let BASE_URL = "http://127.0.0.1:8500/";
//let BASE_URL = "http://81.70.50.27:8069/";
let BASE_URL = "https://wb-api.wanjiayizhan.com/";
let instance2 = axios.create({
  baseURL: BASE_URL,
  timeout: 100000, //超时时间
});
instance2.interceptors.request.use(
  (config) => {
    showLoading();
    if (store.getters.token) {
      config.headers["token"] = getToken();
    }
    if (config.method === "post") {
      config.headers["Content-Type"] = "application/x-www-form-urlencoded";
      config.data = config.data;
      if (config.url.indexOf("/api/v1/new_mgr/update_bar_num") > -1) {
        config.headers["Content-Type"] = "application/json";
        config.data = JSON.stringify(config.data);
      }
      config.headers["token"] = getToken();
    }
    if (config.method === "get") {
      //config.headers['X-CSRF-TOKEN'] = Cookies.get('XSRF-TOKEN')
      config.data = config.data;
      config.headers["token"] = getToken();
    }
    return config;
  },
  (error) => {
    return Promise.reject(error); //报异常
  }
);
instance2.interceptors.response.use(
  (response) => {
    hideLoading();
    if (response.data.result == "登录会话已过期，请重新登录") {
      window.location.href = "/login";
    } else {
      return response;
    }
  },
  (error) => {
    if (error.response) {
      console.log(error);
      if (error.response.data.errmsg !== "渠道包正在生成中，请稍后下载") {
        MessageBox({
          type: "error",
          message: error.response.data.errmsg,
        }).then((action) => {
          if (action == "confirm" && error.response.data.code == 403) {
            //确认的回调
            console.log("退出");
            removeToken();
            window.location.href = "/";
          }
        });
      }
    }
    return Promise.reject(error);
  }
);
let instance3 = axios.create({
  //baseURL: "http://127.0.0.1:8069/",
  baseURL: BASE_URL,
  timeout: 100000, //超时时间
});
instance3.interceptors.request.use(
  (config) => {
    showLoading();
    if (store.getters.token) {
      config.headers["token"] = getToken();
    }
    if (config.method === "post") {
      config.headers["Content-Type"] =
        "application/x-www-form-urlencoded;charset=utf-8";
      config.data = config.data;
      config.headers["token"] = getToken();
    }
    if (config.method === "get") {
      //config.headers['X-CSRF-TOKEN'] = Cookies.get('XSRF-TOKEN')
      config.data = config.data;
      config.headers["token"] = getToken();
    }
    return config;
  },
  (error) => {
    return Promise.reject(error); //报异常
  }
);
instance3.interceptors.response.use(
  (response) => {
    hideLoading();
    return response;
  },
  (error) => {
    if (error.response) {
      console.log(error);
      if (error.response.data.errmsg !== "渠道包正在生成中，请稍后下载") {
        MessageBox({
          type: "error",
          message: error.response.data.errmsg,
        }).then((action) => {
          if (action == "confirm" && error.response.data.code == 403) {
            //确认的回调
            console.log("退出");
            removeToken();
            window.location.href = "/";
          }
        });
      }
    }
    return Promise.reject(error);
  }
);

// 无密码登录

let instance4 = axios.create({
  //baseURL: "http://127.0.0.1:8069/",
  baseURL: BASE_URL,
  timeout: 100000, //超时时间
});
instance4.interceptors.request.use(
  (config) => {
    showLoading();
    if (store.getters.token) {
      config.headers["token"] = getToken();
    }
    if (config.method === "post") {
      config.headers["Content-Type"] = "application/x-www-form-urlencoded";
      config.data = config.data;
      config.headers["token"] = getToken();
    }
    if (config.method === "get") {
      //config.headers['X-CSRF-TOKEN'] = Cookies.get('XSRF-TOKEN')
      config.data = config.data;
      config.headers["token"] = getToken();
    }
    return config;
  },
  (error) => {
    return Promise.reject(error); //报异常
  }
);
instance4.interceptors.response.use(
  (response) => {
    hideLoading();
    return response;
  },
  (error) => {
    if (error.response) {
      console.log(error);
      if (error.response.data.errmsg !== "渠道包正在生成中，请稍后下载") {
        MessageBox({
          type: "error",
          message: error.response.data.errmsg,
        }).then((action) => {
          if (action == "confirm" && error.response.data.code == 403) {
            //确认的回调
            console.log("退出");
            removeToken();
            window.location.href = "/";
          }
        });
      }
    }
    return Promise.reject(error);
  }
);

//支付
let instance5 = axios.create({
  // 支付 8081
  baseURL: "http://127.0.0.1:8069/api/v1/new_pay/",
  //   baseURL: "https://bar-pay.yebaojiasu.com/api/v1/new_pay/",
});
instance5.interceptors.request.use(
  (config) => {
    if (store.state.orderState == "") {
      showLoading();
    }
    setTimeout(function () {
      hideLoading();
    }, 30000);
    const token = getToken() ? getToken() : "";
    config.headers["Content-Type"] =
      "application/x-www-form-urlencoded;charset=utf-8";
    config.headers["Token"] = token;
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
instance5.interceptors.response.use(
  (response) => {
    if (store.state.orderState == "") {
      hideLoading();
    }
    return response;
  },
  function (error) {
    hideLoading();
    return Promise.reject(error);
  }
);

let instance6 = axios.create({
  //   baseURL: "https://new-mgr.yebaojiasu.com/api/v1/new_mgr/", //极限分销接口
  //baseURL: "http://127.0.0.1:8069/api/v1/new_mgr/",
  baseURL: BASE_URL + "api/v1/new_mgr/",
  timeout: 100000, //超时时间
});
instance6.interceptors.request.use(
  (config) => {
    showLoading();
    if (store.getters.token) {
      config.headers["token"] = getToken();
    }
    if (config.method === "post") {
      config.headers["Content-Type"] = "application/x-www-form-urlencoded";
      config.data = config.data;
      config.headers["token"] = getToken();
    }
    if (config.method === "get") {
      //config.headers['X-CSRF-TOKEN'] = Cookies.get('XSRF-TOKEN')
      config.data = config.data;
      config.headers["token"] = getToken();
    }
    return config;
  },
  (error) => {
    return Promise.reject(error); //报异常
  }
);
instance6.interceptors.response.use(
  (response) => {
    hideLoading();
    if (response.data.result == "登录会话已过期，请重新登录") {
      window.location.href = "/login";
    } else {
      return response;
    }
  },
  (error) => {
    if (error.response) {
      console.log(error);
      if (error.response.data.errmsg !== "渠道包正在生成中，请稍后下载") {
        MessageBox({
          type: "error",
          message: error.response.data.errmsg,
        }).then((action) => {
          if (action == "confirm" && error.response.data.code == 403) {
            //确认的回调
            console.log("退出");
            removeToken();
            window.location.href = "/";
          }
        });
      }
    }
    return Promise.reject(error);
  }
);
// 下载渠道包
let instance7 = axios.create({
  baseURL: "http://127.0.0.1:8069/api/v1/new_file/",
  //   baseURL: "https://new-file.yebaojiasu.com/api/v1/new_file/",
});
instance7.interceptors.request.use(
  (config) => {
    showLoading();
    setTimeout(function () {
      hideLoading();
    }, 30000);
    const token = getToken() ? getToken() : "";
    config.headers["Content-Type"] =
      "application/x-www-form-urlencoded;charset=utf-8";
    config.headers["Token"] = token;
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
instance7.interceptors.response.use(
  (res) => {
    hideLoading();
    return res;
  },
  function (error) {
    hideLoading();
    console.log(error);

    return Promise.reject(error);
  }
);

export default {
  instance2,
  instance3,
  instance4,
  instance5,
  instance6,
  instance7,
};
